<template>
    <span>
        <!-- Hover-trigger on large screens -->
        <span
            class="question-icon icon icon-glyphicons-basic-circle-question d-none d-md-inline-block"
            ref="helpTextHover"
            data-trigger="hover"
            :data-content="content"
        >
        </span>
        <!-- Click-trigger on small screens -->
        <a
            class="question-icon icon icon-glyphicons-basic-circle-question d-inline-block d-md-none"
            ref="helpTextClick"
            data-trigger=" focus"
            data-placement="auto"
            :data-content="content"
            tabindex="0"
            role="button"
        >
        </a>
    </span>
</template>

<script>
export default {
    name: "HelpText",
    props: {
        content: {
            type: String,
            required: true,
        },
        placement: {
            type: String,
            required: false,
            default: null,
        },
    },
    mounted() {
        let config = {
            boundary: "window",
        }
        if (this.placement) {
            config.placement = this.placement
        }
        $(this.$refs.helpTextHover).popover(config)
        $(this.$refs.helpTextClick).popover(config)
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.question-icon {
    color: $gray-550;
    font-size: 1.1rem;
    &:hover {
        color: $gray-700;
    }
}
</style>